import { RightEnum, VendorTypeEnum } from "@finway-group/shared/lib/models"
import { type InboxFilter } from "@finway-group/shared/lib/models/invoice/invoiceInbox.filter"
import Form from "antd/lib/form"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { type FilterFormInterface } from "~Components/filter/filterTypes"
import { FormMinMaxDate } from "~Components/form/formMinMaxDate"
import { FormSelect } from "~Components/form/formSelect"
import { useEmployees } from "~Shared/hooks/employee.hooks"
import { getTableFilterObjectStore } from "~Shared/hooks/table.hooks"
import { AuthzService } from "~Shared/services"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { CollapseWrapper } from "~Shared/wrapper/collapse.wrapper"
import { VendorSelect } from "../expenseForm/commonInputFields/VendorSelect"

const adjustFilterObject = (filterObject: InboxFilter): InboxFilter => ({
    ...filterObject,
    minUploadDate: filterObject.minUploadDate ? moment(filterObject.minUploadDate).startOf("day").toDate() : undefined,
    maxUploadDate: filterObject.maxUploadDate ? moment(filterObject.maxUploadDate).endOf("day").toDate() : undefined,
})

export const InboxFilterForm = ({ formInstance, onSubmit, options }: FilterFormInterface) => {
    const { t } = useTranslation()
    const filterObject = getTableFilterObjectStore<InboxFilter>(TablesEnum.INBOX_INVOICE)
    const [filter, setFilter] = useState(adjustFilterObject(filterObject))
    const employees = useEmployees({ excludeDeleted: true })
    const isVendorFilterSelectActive = !!filter?.vendorName

    useEffect(() => {
        formInstance.resetFields()
        setFilter(adjustFilterObject(filterObject))
    }, [])

    return (
        <Form id="expenseFilterForm" className="form--filter" form={formInstance} onFinish={onSubmit}>
            <FormMinMaxDate
                header={t("input:inbox_filter.upload_date_range")}
                min={{
                    name: "minUploadDate",
                    label: t("input:inbox_filter.min_upload_date"),
                    placeholder: t("placeholder:inbox_filter.min_upload_date"),
                    initialValue: filter.minUploadDate,
                }}
                max={{
                    name: "maxUploadDate",
                    label: t("input:inbox_filter.max_upload_date"),
                    placeholder: t("placeholder:inbox_filter.max_upload_date"),
                    initialValue: filter.maxUploadDate,
                }}
                formInstance={formInstance}
            />

            <CollapseWrapper keyCode="" header={t("input:filter_form.vendor")} isCollapse isActive={isVendorFilterSelectActive}>
                <VendorSelect
                    shouldShowOnlyVerifiedVendors={false}
                    shouldRenderSelectDropdown={false}
                    selectedVendorType={VendorTypeEnum.VENDOR}
                    userCreditors={options.userCreditors}
                    selectedCreditorId={filter.vendorName}
                    formProps={{ name: "vendorName", form: formInstance }}
                    valuePropName="name"
                />
            </CollapseWrapper>

            {AuthzService.isRightGrantedForLoggedInUser(RightEnum.INBOX_INVOICE__ALL__READ) && (
                <FormSelect
                    name="uploadedBy"
                    header={t("input:inbox_filter.uploaded_by")}
                    initialValue={filter.uploadedBy}
                    options={employees}
                    isCollapse
                    displayImages
                    showSearch
                    fallback
                />
            )}
        </Form>
    )
}
